import AbstractCanvasTransformTool from "ui/canvas/transforms/AbstractCanvasTransformTool";

/**
 * Transform layer: rotates HSL (Hue, Saturation, Lightness) for each frame
 */
export default class CanvasHSLRotator extends AbstractCanvasTransformTool {
	/**
	 * @param {number} hueDeg
	 * @param {number} saturationPercent
	 * @param {number} lightnessPercent
	 */
	constructor(hueDeg, saturationPercent, lightnessPercent) {
		super();

		/**
		 * @type {number}
		 * @private
		 */
		this._hueDeg = hueDeg;

		/**
		 * @type {number}
		 * @private
		 */
		this._saturationPercent = saturationPercent;

		/**
		 * @type {number}
		 * @private
		 */
		this._lightnessPercent = lightnessPercent;
	}

	/**
	 * @param {HTMLCanvasElement} canvas
	 * @param {CanvasRenderingContext2D} ctx
	 * @param {HTMLImageElement} img
	 * @param {number} frameIndex
	 * @returns {?T_DataSetItem}
	 * @protected
	 */
	_processImage(canvas, ctx, img, frameIndex) {
		let filter = '';

		if (this._hueDeg > 0) {
			filter += `hue-rotate(${this._hueDeg}deg) `;
		}

		if (this._saturationPercent < 100) {
			filter += `saturate(${this._saturationPercent}%) `;
		}


		if (this._lightnessPercent !== 100) {
			filter += `brightness(${this._lightnessPercent}%) `;
		}

		if (filter === '') {
			return null;
		}

		ctx.clearRect(0, 0, this._sceneWidth, this._sceneHeight);
		ctx.save();
		ctx.filter = filter;
		ctx.drawImage(img, 0, 0);
		ctx.restore();
		return this._dataSet.setData(canvas.toDataURL('image/png'));
	}
}
